export const FETCH_COMMENT_LIST_REQUEST = "FETCH_COMMENT_LIST_REQUEST";
export const FETCH_COMMENT_LIST_SUCCESS = "FETCH_COMMENT_LIST_SUCCESS";
export const FETCH_COMMENT_LIST_FAILURE = "FETCH_COMMENT_LIST_FAILURE";